module.exports = __webpack_public_path__ + "static/media/SideBarControle.45a76baf.svg";